import React from "react";
import { motion } from "framer-motion";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-bodyMain py-12 px-6 md:px-20">
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg p-10">
        {/* Page Heading */}
        <motion.h1
          className="text-4xl font-extrabold text-purple-700 text-center mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Terms & Conditions 🐾
        </motion.h1>

        <p className="text-gray-500 text-center mb-8">
          Last Updated: <strong>April 27, 2024</strong>
        </p>

        {/* Section */}
        <motion.section
          className="space-y-8 text-gray-700"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {/* 1. Introduction */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">1. Introduction</h2>
            <p>
              Welcome to Popout! We provide pet delivery and walking services in the
              United Arab Emirates (UAE). These Terms apply to all users, including customers,
              partners, and third parties.
            </p>
          </div>

          {/* 2. Acceptance of Terms */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">2. Acceptance of Terms</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>You must be 18 years old or above.</li>
              <li>You must have the legal capacity to enter into this agreement.</li>
              <li>By using Popout, you agree to comply with these Terms.</li>
            </ul>
          </div>

          {/* 3. Services */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">3. Description of Services</h2>
            <p>Popout offers the following services:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>🐶 Pet Delivery – Safe transport for pets across the UAE.</li>
              <li>🐕 Pet Walking – Reliable, professional pet walking services.</li>
              <li>🛁 Additional Services – Grooming, boarding, training (as available).</li>
            </ul>
          </div>

          {/* 4. User Responsibilities */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">4. User Responsibilities</h2>
            <p>As a Popout user, you must:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Be the pet owner or have proper authorization.</li>
              <li>Follow all UAE pet ownership laws.</li>
              <li>Not use our Services for fraudulent, abusive, or illegal activities.</li>
            </ul>
          </div>

          {/* 5. Payment & Refund Policy */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">5. Payment & Refund Policy</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>💳 Payments can be made via MamoPay or Cash on Delivery.</li>
              <li>📌 All charges will be displayed before confirming a booking.</li>
              <li>🔄 For refund requests, refer to our [Refund Policy].</li>
            </ul>
          </div>

          {/* 6. Privacy Policy */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">6. Privacy Policy</h2>
            <p>
              Your privacy is important to us. Read our [Privacy Policy] to understand how we
              collect, use, and protect your information.
            </p>
          </div>

          {/* 7. Account Termination */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">7. Account Termination</h2>
            <p>
              Popout reserves the right to suspend or terminate accounts if users violate our
              Terms or engage in harmful behavior.
            </p>
          </div>

          {/* 8. Liability & Indemnification */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">
              8. Liability & Indemnification
            </h2>
            <p>
              Popout is not liable for indirect, incidental, or consequential damages, including
              loss of data or profits.
            </p>
          </div>

          {/* 9. Governing Law */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">9. Governing Law</h2>
            <p>These Terms are governed by the laws of the United Arab Emirates (UAE).</p>
          </div>

          {/* 10. Contact Information */}
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">10. Contact Information</h2>
            <p>If you have any questions, reach out to us at:</p>
            <ul className="list-disc pl-6">
              <li>📧 Email: info@mypawdash.com</li>
              <li>📍 Address: Abu Dhabi, UAE</li>
              <li>📞 Phone: +971 509 921 927</li>
            </ul>
          </div>
        </motion.section>

        {/* Back to Home Button */}
        <div className="mt-8 flex justify-center">
          <motion.a
            href="/"
            className="px-6 py-3 bg-purple-700 text-dark text-lg rounded-lg shadow-lg hover:bg-purple-800 transition-all"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Back to Home
          </motion.a>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
